import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Virus = function Virus(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 2v5m0-5c-.7133 0-1.4091.0747-2.08.2166M12 2a10.04 10.04 0 0 1 2.08.2166M12 7c-2.7614 0-5 2.2386-5 5m5-5c2.7614 0 5 2.2386 5 5m-5 5v5m0-5c2.7614 0 5-2.2386 5-5m-5 5c-2.7614 0-5-2.2386-5-5m5 10c.7122 0 1.407-.0745 2.077-.216M12 22c-.7149 0-1.4122-.075-2.0845-.2176M4.9289 4.9289l3.5355 3.5356m7.0711 7.071 3.5355 3.5356M2 12h5m-5 0c0 .7133.0747 1.4092.2166 2.0802M2 12c0-.7143.0749-1.4112.2173-2.0832M17 12h5m0 0c0-.7133-.0747-1.4092-.2167-2.0802M22 12c0 .7131-.0746 1.4086-.2165 2.0794M4.9289 19.0711l3.5355-3.5356m7.0711-7.071 3.5355-3.5356m-1.6244-1.3168a10.05 10.05 0 0 1 2.9422 2.9426m-.0028 10.8949a10.05 10.05 0 0 1-2.9415 2.9397m-10.8908-.0011a10.055 10.055 0 0 1-2.939-2.9374m-.003-10.897a10.05 10.05 0 0 1 2.941-2.9414"
    })
  }));
};
export default Virus;